var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionBasic',{attrs:{"id":"about","isActive":_vm.isActive}},[_c('h3',{staticClass:"txt_section"},[_vm._v("About us")]),_c('p',{staticClass:"tit_section"},[_vm._v("용돈 교육을 시작으로,"),_c('br'),_vm._v("레몬트리가 앞장서겠습니다.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }